
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/new_recruiter_future/[slug]",
      function () {
        return require("private-next-pages/new_recruiter_future/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/new_recruiter_future/[slug]"])
      });
    }
  